const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "CLEAR_VESSEL_IMAGES":
            return initialState;
        case "VESSEL_IMAGES_RETRIEVED":
            return action.data;

        default:
            return state;
    }
}
